import { render, staticRenderFns } from "./TransferResults.vue?vue&type=template&id=22a8a29a"
import script from "./TransferResults.vue?vue&type=script&lang=js"
export * from "./TransferResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports